import api from 'api';

export const USER_BRANDS_UPDATE_ACTION_SUCCESS = 'USER_BRANDS_UPDATE_ACTION_SUCCESS';
export const USER_BRANDS_UPDATE_ACTION_ERROR = 'USER_BRANDS_UPDATE_ACTION_ERROR';
export const USER_BRAND_ADD_ACTION_SUCCESS = 'USER_BRAND_ADD_ACTION_SUCCESS';
export const USER_BRAND_UPDATE_ACTION_SUCCESS = 'USER_BRAND_UPDATE_ACTION_SUCCESS';
export const USER_BRAND_ADD_LOCATION_ACTION_SUCCESS = 'USER_BRAND_ADD_LOCATION_ACTION_SUCCESS';
export const USER_BRAND_UPDATE_LOCATION_ACTION_SUCCESS = 'USER_BRAND_UPDATE_LOCATION_ACTION_SUCCESS';
export const USER_BRANDS_RESET_STATE = 'USER_BRANDS_RESET_STATE';
export const USER_BRAND_ADD_BRAND_PROPERTY = 'USER_BRAND_ADD_BRAND_PROPERTY';
export const USER_BRAND_REMOVE_BRAND_PROPERTY = 'USER_BRAND_REMOVE_BRAND_PROPERTY';
export const USER_BRAND_UPDATE_BRAND_PROPERTY = 'USER_BRAND_UPDATE_BRAND_PROPERTY';

export function updateUserBrandsSuccess(data) {
  return {
    type: USER_BRANDS_UPDATE_ACTION_SUCCESS,
    data,
  };
}

export function updateUserBrandSuccess(data) {
  return {
    type: USER_BRAND_UPDATE_ACTION_SUCCESS,
    data,
  };
}

export function addUserBrandSuccess(data) {
  return {
    type: USER_BRAND_ADD_ACTION_SUCCESS,
    data,
  };
}

export function updateUserBrandsError(error) {
  return {
    type: USER_BRANDS_UPDATE_ACTION_ERROR,
    error,
  };
}

export function addUserBrandLocationSuccess(data) {
  return {
    type: USER_BRAND_ADD_LOCATION_ACTION_SUCCESS,
    data,
  };
}

export function updateUserBrandLocationSuccess(data) {
  return {
    type: USER_BRAND_UPDATE_LOCATION_ACTION_SUCCESS,
    data,
  };
}

export function resetUserBrandsState() {
  return {
    type: USER_BRANDS_RESET_STATE,
  };
}

/**
 * Call create brand property API and update brand with brand property
 * @param {*} brandProperty
 * @param {*} brandId
 * @param {*} updated timestamp
 * @returns
 */
export const createBrandPropertyAsync = (brandProperty, brandId, updated) => {
  return (dispatch) => {
    return api.request(`brand/${ brandId }/properties`, 'post', brandProperty)
    .then(() => {
      dispatch({
        type: USER_BRAND_ADD_BRAND_PROPERTY,
        data: { ...brandProperty, brandId, updated },
      });
    })
    .catch((err) => {
      dispatch(updateUserBrandsError('Unable to create brand property'));
      throw (err);
    });
  };
};

/**
 * Call user/current API to fetch brand properties and delete the property 
 * if it is not available in the fetched brand properties.
 * @param {*} brandId
 * @param {*} property
 * @returns
 */
export function removeUserBrandProperty(brandId, property) {
  return (dispatch) => {
    return api.request('user/current', 'get')
      .then((data) => {
        const brandProperties = data.brands[0].brandProperties;
        if (!brandProperties[property]) {
          dispatch({
            type: USER_BRAND_REMOVE_BRAND_PROPERTY,
            data: { ...brandProperties, brandId, property },
          });
        }
      })
      .catch((err) => {
        throw (err);
      });
  };
}

/**
 * Update brand property locally
 * @param {Object} param1 brandProperty { brandId, propertyType, propertyKey, propertyValue }
 * @returns action
 */
export const updateBrandProperty = ({ brandId, propertyType, propertyKey, propertyValue }) => ({
  type: USER_BRAND_UPDATE_BRAND_PROPERTY,
  payload: { brandId, propertyType, propertyKey, propertyValue }
});
